// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backdrop-bloqueio {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  flex-direction: row;
  align-items: center;
  background-color: rgba(255, 255, 255, 0);
  justify-content: center;
  opacity: 0;
  animation: opacity-bloqueio 1s ease-in-out forwards;
}
.backdrop-bloqueio .texto-bloqueio {
  padding: 0 40px;
  font-size: 26px;
  color: #4d4d4d;
  font-weight: normal;
}

@keyframes opacity-bloqueio {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/checkout/components/checkout/backdrop-bloqueio/backdrop-bloqueio.component.scss"],"names":[],"mappings":"AAAA;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,uBAAA;EACA,UAAA;EACA,mDAAA;AACF;AACE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAGA;EACE;IAAK,UAAA;EACL;EAAA;IAAO,UAAA;EAGP;AACF","sourcesContent":[".backdrop-bloqueio {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  position: fixed;\n  flex-direction: row;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0);\n  justify-content: center;\n  opacity: 0;\n  animation: opacity-bloqueio 1s ease-in-out forwards;\n\n  .texto-bloqueio {\n    padding: 0 40px;\n    font-size: 26px;\n    color: #4d4d4d;\n    font-weight: normal;\n  }\n}\n\n@keyframes opacity-bloqueio {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
